import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { BaseButton } from '@bnnvara/buttons';
import { GridItem } from '@bnnvara/grids';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import { FetchPersonOverview } from '../../../api/queries/person.gql';
import BasePersonItemCard from '../../cards/PersonItemCard';
import Paginator from '../../Paginator';

const PersonItemCard = React.forwardRef((props, forwardedRef) => {
  const { slug } = props;
  return (
    <GridItem
      ref={forwardedRef}
      columnEndSm="span 12"
      columnEndMd="span 6"
      columnEndLg="span 3"
      key={slug}
    >
      <BasePersonItemCard {...props} />
    </GridItem>
  );
});

PersonItemCard.defaultProps = {
  slug: null,
};

PersonItemCard.propTypes = {
  slug: PropTypes.string,
};

const loadMoreButton = (
  <BaseButton variant="underline">
    <span
      onClick={() => {
        track('personenoverzichtNieuw', 'click', 'toon-meer-items');
      }}
      onKeyDown={() => {
        track('personenoverzichtNieuw', 'click', 'toon-meer-items');
      }}
      role="button"
      tabIndex={0}
    >
      Toon meer items
    </span>
  </BaseButton>
);

const PersonOverview = () => {
  const { slug: brandSlug } = useBrand();
  const {
    query: { index },
  } = useRouter();

  const formattedIndex = index ? index.substring(0, 1) : null;

  return (
    <Paginator
      limit={8}
      ItemComponent={PersonItemCard}
      query={FetchPersonOverview}
      variables={{
        brandSlug,
        index: formattedIndex,
      }}
      itemsKey="brand.personOverview.persons"
      loadMoreElement={loadMoreButton}
    />
  );
};

export default PersonOverview;
